import { Space, Typography } from 'antd'
import { t } from 'i18next'
import React from 'react'
interface LimitInfoRowProps {
    title: string
    value: string
  }
function LimitTableUtilColumn({ data }: { data: LimitInfoRowProps[] }) {
  return (
    <Space.Compact  direction="vertical">
    {data.map(({ title, value }) => (
      <Space key={title}>
        <Typography.Text  style={{fontSize:"14px",fontWeight:300,color:"#000"}}>{title + ':'}</Typography.Text>
        <Typography.Text style={{fontSize:"12px",fontWeight:300,color:"#000"}} >{value}</Typography.Text>
      </Space>
    ))}
  </Space.Compact>
  )
}

export default LimitTableUtilColumn